const actions = {

    GET_COUNTRY_LIST: 'GET_COUNTRY_LIST',
    GET_COUNTRY_LIST_SUCCESS: 'GET_COUNTRY_LIST_SUCCESS',
    GET_COUNTRY_LIST_FAILURE: 'GET_COUNTRY_LIST_FAILURE',
    
    GET_SECTORS: 'GET_SECTORS',
    GET_SECTORS_SUCCESS: 'GET_SECTORS_SUCCESS',
    GET_SECTORS_FAILURE: 'GET_SECTORS_FAILURE',

    AGENT_LOGIN_AS_USER: 'AGENT_LOGIN_AS_USER',
    AGENT_LOGIN_AS_USER_SUCCESS: 'AGENT_LOGIN_AS_USER_SUCCESS',
    AGENT_LOGIN_AS_USER_FAILURE: 'AGENT_LOGIN_AS_USER_FAILURE',

    AGENT_ACT_AS_CUSTOMER_ID: 'AGENT_ACT_AS_CUSTOMER_ID',
    AGENT_ACT_AS_CUSTOMER_ID_SUCCESS: 'AGENT_ACT_AS_CUSTOMER_ID_SUCCESS',
    AGENT_ACT_AS_CUSTOMER_ID_FAILURE: 'AGENT_ACT_AS_CUSTOMER_ID_FAILURE',

    AGENT_UPDATE_QUOTE_DATA: 'AGENT_UPDATE_QUOTE_DATA',
    AGENT_UPDATE_QUOTE_DATA_SUCCESS: 'AGENT_UPDATE_QUOTE_DATA_SUCCESS',
    AGENT_UPDATE_QUOTE_DATA_FAILURE: 'AGENT_UPDATE_QUOTE_DATA_FAILURE',
    
    GET_QUOTES_AND_ORDERS_FOR_MAP: 'GET_QUOTES_AND_ORDERS_FOR_MAP',
    GET_QUOTES_AND_ORDERS_FOR_MAP_SUCCESS: 'GET_QUOTES_AND_ORDERS_FOR_MAP_SUCCESS',
    GET_QUOTES_AND_ORDERS_FOR_MAP_FAILURE: 'GET_QUOTES_AND_ORDERS_FOR_MAP_FAILURE',

    RESET_UPDATED_QUOTE: 'RESET_UPDATED_QUOTE',

    //DASHBOARD (AGENT)
    SET_USER_STATE: "SET_USER_STATE",
    SET_CUSTOMER_LIST: 'SET_CUSTOMER_LIST',
    SET_ACTIVE_CUSTOMER_IN_LIST: 'SET_ACTIVE_CUSTOMER_IN_LIST',

  }
  
  export default actions;
  